import { get } from '../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../config'

// 获取系统配置信息
export const GET_SYSTEM_CONFIG_INFO = (data) => {
  return get(`${OPERATION_CENTER_PREFIX}/common/v1/cos`, data)
}
